import "./EditUserProfile.scss";

import { Form, Formik } from "formik";
import React, { useState } from "react";
import Button from "ui/build/components/Button/Button";
import Input from "ui/build/components/Inputs/Input";
import MonadModal from "ui/build/components/Modal/MonadModal";
import Para from "ui/build/components/Para/Para";
import { v4 as uuidv4 } from "uuid";
import * as Yup from "yup";

import { t } from "../../../../utils/ResourceUtils";
import getRuntimeConfig from "../../../../utils/runtimeConfig";
import { avatarList } from "../../../../utils/StaticData";
import {
  AvatarImage,
  getEditUserProfileValidationForm,
  getEnableChangePasswordAndMobileNumberFields,
  handleFormikSubmit,
  handleProfilePicModalCancel,
  handleProfilePicModalSubmit,
  onModalSubmit,
} from "./EditUserProfile.utils";

export default function EditUserProfile({
  open,
  onCancel,
  options,
  userData,
  handleChangeFun,
  handleProfilePic,
  handleSaveProfilePic,
  selectedAvatar,
  btnDisable,
}) {
  const enableChangePasswordAndMobileNumberFields = getEnableChangePasswordAndMobileNumberFields(getRuntimeConfig);
  const [showUploadAvatar, setShowUploadAvatar] = useState(false);
  const [tempAvatarSelection, setTempAvatarSelection] = useState(userData?.userPicURL);
  const validationForm = getEditUserProfileValidationForm(Yup);
  return (
    <MonadModal
      className="profile-popup"
      variant="regular-modal"
      size="md"
      open={open}
      onSubmit={onModalSubmit}
      onCancel={onCancel}
      heading={options?.heading}
      body={
        <Formik
          initialValues={userData}
          enableReinitialize={true}
          onSubmit={handleFormikSubmit}
          validationSchema={validationForm}
        >
          {({ touched, errors, handleBlur, handleSubmit, setFieldValue }) => (
            <Form onSubmit={handleSubmit}>
              <div
                className={`profile-block password-change-${
                  enableChangePasswordAndMobileNumberFields ? "enable" : "disable"
                } row`}
              >
                <div className="row w-100">
                  <div className="col-9 pr-0">
                    <div className="col-12">
                      <Input
                        type="text"
                        placeholder={t("cm.first_name")}
                        name="firstName"
                        label={t("cm.first_name")}
                        autoComplete="off"
                        isMandatory
                        value={userData?.firstName}
                        onChange={(e) => handleChangeFun(e, setFieldValue)}
                        onBlur={handleBlur}
                      />
                      {errors.firstName && touched.firstName && <div className="error">{errors.firstName}</div>}
                    </div>
                    <div className="col-12">
                      <Input
                        type="text"
                        placeholder={t("cm.last_name")}
                        name="lastName"
                        label={t("cm.last_name")}
                        autoComplete="off"
                        value={userData?.lastName}
                        onChange={(e) => handleChangeFun(e, setFieldValue)}
                      />
                    </div>
                    <div className="col-12">
                      <Input
                        type="text"
                        placeholder={t("cm.email_ID")}
                        name="emailId"
                        label={t("cm.email_ID")}
                        autoComplete="off"
                        disabled="disabled"
                        value={userData?.email}
                        onChange={(e) => handleChangeFun(e, setFieldValue)}
                      />
                    </div>
                  </div>
                  <div className="col-3 profile-section">
                    <label>{t("cm.profile_photo")}</label>
                    <div>
                      {selectedAvatar?.trim?.() ? (
                        <img className="img-design" src={`/assets/${selectedAvatar}.png`} alt="image" />
                      ) : (
                        <img className="img-design" src="/assets/Default.png" alt="image" />
                      )}
                    </div>
                    <div className="text-center btn-size">
                      <Button variant="outline" onClick={() => setShowUploadAvatar(true)}>
                        {t("cm.upload_image")}
                      </Button>

                      <MonadModal
                        variant="regular-modal"
                        open={showUploadAvatar}
                        submitText={t("cm.select")}
                        cancelText={t("cm.cancel")}
                        onSubmit={() =>
                          handleProfilePicModalSubmit({ handleProfilePic, tempAvatarSelection, setShowUploadAvatar })
                        }
                        onCancel={() =>
                          handleProfilePicModalCancel({ setShowUploadAvatar, setTempAvatarSelection, userData })
                        }
                        heading={t("cm.choose_avatar")}
                        body={
                          <div className="avatar-list">
                            <React.Fragment>
                              {avatarList.map((avatar) => (
                                <AvatarImage
                                  key={uuidv4()}
                                  setTempAvatarSelection={setTempAvatarSelection}
                                  avatar={avatar}
                                  className={`avatar-pic ${
                                    tempAvatarSelection === avatar.alt ? "selected-avatar" : ""
                                  }`}
                                  src={avatar.src}
                                  alt={avatar.alt}
                                ></AvatarImage>
                              ))}
                            </React.Fragment>
                          </div>
                        }
                        footer={true}
                      />
                      <Para className="photo-remove" onClick={() => handleProfilePic("")}>
                        {t("cm.remove_photo")}
                      </Para>
                    </div>
                  </div>
                </div>
                <div className="profile-actions d-flex justify-content-end w-100 pr">
                  <Button variant="outline" onClick={onCancel}>
                    {options?.cancelText}
                  </Button>
                  <Button type="submit" onClick={() => handleSaveProfilePic(selectedAvatar)} disabled={btnDisable}>
                    {options?.submitText}
                  </Button>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      }
    />
  );
}
